import { Host, h } from "@stencil/core";
export class ListItemIcon {
    constructor() {
        this.right = false;
    }
    render() {
        return (h(Host, { key: '9fb09192dd52850fcef91ea5a331d15a4b3b5dcc', class: {
                'bal-list__item__icon': true,
                'bal-list__item__icon--right': this.right,
            } }, h("slot", { key: 'cd11e4ae80df1279bb2ba2ea033177e2853e9f78' })));
    }
    static get is() { return "bal-list-item-icon"; }
    static get properties() {
        return {
            "right": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If `true` the icon is on the right side of the list item. Default is the left side."
                },
                "getter": false,
                "setter": false,
                "attribute": "right",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
}
